module.exports = __webpack_public_path__ + "static/media/C20-0053_AW_PBN_Desktop_2396x1473_Work.d498b044.jpg";